﻿import { useTranslation } from "react-i18next";
import TopBar from "@/pages/home/components/TopBar";
import Header from "@/pages/home/components/Header";
import Footer from "@/pages/home/components/Footer";
import StickyMobile from "@/pages/home/components/StickyMobile";
import Breadcrumb from "./components/Breadcrumb";
import Hero from "./components/Hero";
import SpoedBanner from "./components/SpoedBanner";
import IntroText from "./components/IntroText";
import WanneerVervangen from "./components/WanneerVervangen";
import TypesSloten from "./components/TypesSloten";
import SKGKeurmerk from "./components/SKGKeurmerk";
import Werkwijze from "./components/Werkwijze";
import Prijzen from "./components/Prijzen";
import WaaromWij from "./components/WaaromWij";
import FAQ from "./components/FAQ";
import InterneLinks from "./components/InterneLinks";
import CTABanner from "./components/CTABanner";
import OfferteForm from "./components/OfferteForm";

function SchemaMarkup() {
  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "Slot- en cilindervervanging Eindhoven",
    provider: {
      "@type": "LocalBusiness",
      name: "Ramen Repair Eindhoven",
      url: "https://ramen-repair-eindhoven.nl/",
      telephone: "+31407987470",
      email: "info@ramen-repair-eindhoven.nl",
      address: {
        "@type": "PostalAddress",
        addressLocality: "Eindhoven",
        addressRegion: "Noord-Brabant",
        addressCountry: "NL",
      },
      areaServed: {
        "@type": "City",
        name: "Eindhoven",
      },
    },
    serviceType: "Slot- en cilindervervanging",
    description: "Slot en cilinder vervangen in Eindhoven. SKG-keurmerk. Spoedservice 7/7.",
    offers: {
      "@type": "AggregateOffer",
      priceCurrency: "EUR",
      lowPrice: "65",
      highPrice: "185",
    },
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://ramen-repair-eindhoven.nl/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Diensten",
        item: "https://ramen-repair-eindhoven.nl/onze-diensten/",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Slot vervangen",
        item: "https://ramen-repair-eindhoven.nl/slot-cilinder-vervangen/",
      },
    ],
  };

  const { t } = useTranslation("slot-cilinder-vervangen");
  const faqItems = t("faq.items", { returnObjects: true }) as Array<{
    q: string;
    a: string;
  }>;

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqItems.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.a,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(serviceSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
    </>
  );
}

export default function SlotCilinderVervangen() {
  const { t } = useTranslation("slot-cilinder-vervangen");

  return (
    <main className="bg-white min-h-screen">
      <title>{t("seo.title")}</title>
      <meta name="description" content={t("seo.description")} />
      <meta property="og:title" content={t("seo.title")} />
      <meta property="og:description" content={t("seo.description")} />
      <meta property="og:locale" content="nl_NL" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://ramen-repair-eindhoven.nl/slot-cilinder-vervangen/" />
      <meta property="og:image" content="/og/og-slot.jpg" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="Ramen Repair Eindhoven - kozijn en raamreparatie" />
      <link rel="canonical" href="https://ramen-repair-eindhoven.nl/slot-cilinder-vervangen/" />
      <link rel="alternate" hreflang="nl-NL" href="https://ramen-repair-eindhoven.nl/slot-cilinder-vervangen/" />
      <link rel="alternate" hreflang="x-default" href="https://ramen-repair-eindhoven.nl/slot-cilinder-vervangen/" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={t("seo.title")} />
      <meta name="twitter:description" content={t("seo.description")} />
      <meta name="twitter:image" content="/og/og-slot.jpg" />
      <SchemaMarkup />
      <TopBar />
      <Header />
      <Breadcrumb />
      <Hero />
      <SpoedBanner />
      <IntroText />
      <WanneerVervangen />
      <TypesSloten />
      <SKGKeurmerk />
      <Werkwijze />
      <Prijzen />
      <WaaromWij />
      <FAQ />
      <InterneLinks />
      <CTABanner />
      <OfferteForm />
      <Footer />
      <StickyMobile />
    </main>
  );
}